import { useCallback, useState } from 'react';

interface UseFileUploadProps {
  value: File | string | null | undefined;
  onChange: (value: File | string | null) => void;
}

export const useFileUpload = ({ value, onChange }: UseFileUploadProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<'file' | 'link'>(
    typeof value === 'string' ? 'link' : 'file'
  );

  const openDialog = useCallback(() => {
    setIsDialogOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setIsDialogOpen(false);
  }, []);

  const handleFileChange = useCallback(
    (value: File) => {
      onChange(value);
      closeDialog();
    },
    [onChange, closeDialog],
  );

  const handleLinkChange = useCallback(
    (value: string) => {
      onChange(value);
      closeDialog();
    },
    [onChange, closeDialog],
  );

  const handleDelete = useCallback(() => {
    onChange(null);
  }, [onChange]);

  return {
    isDialogOpen,
    activeTab,
    setActiveTab,
    openDialog,
    closeDialog,
    handleFileChange,
    handleLinkChange,
    handleDelete,
  };
}; 